import React, { Component, Fragment } from "react";
import {
  Row,
  Col,
  Button,
  InputGroup,
  InputGroupAddon,
  Input
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import Autocomplete from "../controls/_Autocomplete";
import Messages from '../../notifications/Messages';
import Errors from '../../notifications/Errors';
import Tooltip from '../controls/Tooltip';
import { formatDateTime, barCodeFirst, currentDate, customSelectStyles ,parseDatetime} from '../../lib/common';
import Sound from 'react-sound';
import mp3Success from '../../sound/alert-success.mp3';
import mp3AddItem from '../../sound/alert-add-item.mp3';
const isNumber = require('is-number');
import { storedb } from '../client/storedb';
import { BtnPermissions } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
// Import actions
import * as nhapkhoConstant from './constants';
import * as nhapkhoAction from './actions';

class NhapKho extends Component {
  constructor(props) {
    var dbContext = storedb();
    super(props);
    this.state = {
      store_id: dbContext.getStoreId(),
      kho_id: dbContext.getKhoId(),
      item: {},
      itemNhap: {
        trangThai: 0,
        loaiHd: nhapkhoConstant.LOAI_DH.TU_NCC,
        customerId: 0,
        customerName: '',
        soPhieu: "",
        maSoThue: "",
        ghiChu: ""
      },
      list: [],
      listNcc: [],
      listKho: [],
      page: 1,
      per_page: 20,
      TotalAmount: 0,
      Refund: 0,
      TotalPay: 0,
      TotalVisitorPay: "",
      HanDung: currentDate().add(2, 'years'),
      NgayNhap: currentDate(),
      suggestions: [],
      MessWarning: "",
      optionsDvt: null,
      maBarcode: null,
      closeSuggession: null,
      playSound: Sound.status.STOPPED,
      soundUrl: '',
      ProductId: 0,
      selectedOptionNcc: null,
      selectedOptionKho: null,
      customerSuggestions: [],
      customersCtl: {}
    };
    this.handleMoneyImChange = this.handleMoneyImChange.bind(this);
    this.handleMoneyOutChange = this.handleMoneyOutChange.bind(this);
    this.listDsNhap = this.listDsNhap.bind(this);
  }

  initState = (callback) => {
    var dbContext = storedb();
    this.setState({
      store_id: dbContext.getStoreId(),
      kho_id: dbContext.getKhoId(),
      item: {},
      list: [],
      page: 1,
      per_page: 20,
      TotalAmount: 0,
      Refund: 0,
      TotalPay: 0,
      TotalVisitorPay: "",
      HanDung: currentDate().add(2, 'years'),
      NgayNhap: currentDate(),
      MessWarning: "",
      modalUpdatemasterProducts: false,
      modalUpdateNcc: false,
      customerSuggestions: []
    }, callback);
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1), // remove the "?" at the start
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  listDsNhap = () => {
    setTimeout(() => {
      this.props.history.push("/imports");
    }, 1000)
  }
  removeItem(obj, e) {
    let { list } = this.state;
    let index = list.findIndex(x => x.idproduct === obj.idproduct);
    if (index > -1) {
      list.splice(index, 1);
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }

  formatOptions = (list) => {
    let suggestions = [];
    let productKhosBarcode = null;
    if (this.state.maBarcode) {
      productKhosBarcode = list.filter(item => item.BarCodeTon == this.state.maBarcode || item.BarCode == this.state.maBarcode);
      if (productKhosBarcode && productKhosBarcode.length == 1) {
        let option = null;
        productKhosBarcode.forEach(function (item) {
          option = {
            value: item.Id,
            label: item.Ten,
            sku: item.Sku,
            giaban: item.GiaBan || 0,
            gianhap: item.GiaNhap || 0,
            // QuyCach: item.QuyCach || 1,
            QuyCach: 1,
            DvtTen: item.DvtTen || "Hộp",
            DvtId: item.DvtId || 5,
            tonkho: item.TonKho && item.TonKho != 0 ? ('\u00A0Tồn :' + item.TonKho || "") : "",
            QuyCachDongGoi: item.QuyCachDongGoi || "",
            type: item.Type,
            idproduct: item.Id,
            BarCode: item.BarCodeTon || (item.BarCode || "")
          };
        });
        this.addItem(option);
        this.setState({ maBarcode: null });

        //close suggess auto search
        this.closeSuggessionHandle();
        return;
      }
    }
    let productKhos = list.filter(item => item.Type == 1);
    let products = list.filter(item => item.Type == 2);

    productKhos.forEach(function (item) {
      let option = null;
      let index = suggestions.findIndex(x => x.type == item.Type && x.category);
      if (index == -1) {
        option = {
          category: true,
          label: "Hàng trong kho",
          type: item.Type
        };
        suggestions.push(option);
      }
      option = {
        value: item.Id,
        label: item.Ten,
        sku: item.Sku,
        giaban: item.GiaBanTon || (item.GiaBan || 0),
        gianhap: item.GiaNhapTon || (item.GiaNhap || 0),
        // QuyCach: item.QuyCach || 1,
        QuyCach: 1,
        DvtTen: item.DvtTen || "Hộp",
        DvtId: item.DvtId || 5,
        tonkho: '\u00A0Tồn :' + item.TonKho || "",
        QuyCachDongGoi: item.QuyCachDongGoi || "",
        type: item.Type,
        idproduct: item.Id,
        BarCode: item.BarCodeTon || (item.BarCode || "")
      };
      suggestions.push(option);
    });

    products.forEach(function (item) {
      let option = null;
      let index = suggestions.findIndex(x => x.type == item.Type && x.category);
      if (index == -1) {
        option = {
          category: true,
          label: "Hàng yêu cầu nhập kho",
          type: item.Type
        };
        suggestions.push(option);
      }
      option = {
        value: item.Id,
        label: item.Ten,
        sku: item.Sku,
        giaban: item.GiaBan || 0,
        gianhap: item.GiaNhap || 0,
        // QuyCach: item.QuyCach || 1,
        QuyCach: 1,
        DvtTen: item.DvtTen || "Hộp",
        DvtId: item.DvtId || 5,
        tonkho: "",
        QuyCachDongGoi: item.QuyCachDongGoi || "",
        type: item.Type,
        idproduct: item.Id,
        BarCode: item.BarCodeTon || (item.BarCode || "")
      };
      suggestions.push(option);
    });

    this.setState({ suggestions });
  }
  setCloseSuggessHandle = (callback) => {
    const self = this;
    if (typeof callback == 'function') {
      let { closeSuggession } = self.state;
      if (closeSuggession == null) {
        self.setState({ closeSuggession: callback });
      }
    }
  }

  closeSuggessionHandle = () => {
    const { closeSuggession } = this.state;

    if (typeof closeSuggession == 'function') {
      closeSuggession({ isResetTextbox: true, isCloseSuggessDelegate: true });
    }
  }
  onHandleSelectChange = (selectedOption) => {
    if (!selectedOption) {
      return;
    }
    if (selectedOption.category) {
      return;
    }
    this.addItem(selectedOption);
  }
  productChanged = (input, callback) => {
    var maBarcodeNew = input.replace("-", "");
    if (isNumber(maBarcodeNew)) {
      this.setState({ maBarcode: input });
    };
    this.search_products(input, callback);
  }

  formatOptionLabel = (option) => {
    if (option.category) {
      return (
        <div className="category category_dislable">
          <em>{option.label}</em>
        </div>
      )
    }
    else {
      if (option.type == 0) {
        return (
          <div className="item">
            {'\u00A0'}{'\u00A0'}{option.sku}/{option.label}
          </div>
        )
      }
      else {
        return (
          <div className="item">
            {'\u00A0'}{'\u00A0'}
            {option.sku}/{option.label}
            <span className={"item_unit"}>{'\u00A0'}({option.DvtTen}{option.tonkho})</span>
          </div>
        )
      }
    }
  }

  formatNoOptionLabel = (input) => {
    return (
      <Fragment>
        <em>Không tìm thấy sản phẩm nào</em>
        <a href="#/products-edit?pid=" target="_blank" ><i className="fa fa-plus"></i>{'\u00A0'}Thêm hàng</a> vào kho
      </Fragment>
    )
  }
  search_products(keyword, callback) {
    const { nhapkhoListProductRequest } = this.props
    var requestData = {
      keyword: keyword,
      store_id: this.state.store_id,
      kho_id: this.state.kho_id,
      module: 2,//import
      per_page: this.state.per_page
    }
    return nhapkhoListProductRequest(requestData, callback)
  }
  fetchListNhaCC = () => {
    const { nhapkhoListNhaCCRequest } = this.props

    var requestData = {
      stores_id: this.state.store_id,
      page: 1,
      per_page: 200
    };
    return nhapkhoListNhaCCRequest(requestData);
  }
  buildSelectOptionNcc(listNcc) {
    var options = [];
    if (listNcc && listNcc.length > 0) {
      listNcc.map((item) => { options.push({ value: item.NhaCCId, label: item.Ten }) }
      );
    }
    return options;
  }

  fetchListKho = () => {
    const { nhapkhoListKhoRequest } = this.props
    var requestData = {
      StoreId: this.state.store_id,
      keyword: null,
      status: 1,
      cap: 1,
      page: 1,
      per_page: 200
    };
    return nhapkhoListKhoRequest(requestData);
  }
  buildSelectOptionKho(listKho) {
    var options = [];
    if (listKho && listKho.length > 0) {
      listKho.map((item) => { options.push({ value: item.KhoId, label: item.Ten }) }
      );
    }
    return options;
  }
  componentDidMount() {
    this.fetchListNhaCC();
    this.fetchListKho();
    this.initState(() => {
      this.props.nhapkhoProductsListDvtRequest();
      this.search_products('');
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.nhapkho.type == nhapkhoConstant.NHAPKHO_LIST_NCC_SUCCESS) {
      let { listNcc } = nextProps.nhapkho;
      this.setState({
        listNcc: this.buildSelectOptionNcc(listNcc)
      });
    }
    else if (nextProps.nhapkho.type == nhapkhoConstant.NHAPKHO_LIST_KHO_SUCCESS) {
      let { listKho } = nextProps.nhapkho;
      this.setState({
        listKho: this.buildSelectOptionKho(listKho)
      });
    }
    else if (nextProps.nhapkho.type == nhapkhoConstant.NHAPKHO_LIST_PRODUCT_SUCCESS) {
      let { list } = nextProps.nhapkho;
      this.formatOptions(list);
    }
    else if (nextProps.nhapkho.type == nhapkhoConstant.NHAPKHO_SAVE_SUCCESS) {
      this.setSoundStatus(mp3Success);
      this.initState();
    }
    else if (nextProps.nhapkho.type == nhapkhoConstant.NHAPKHO_PRODUCTS_LIST_DVT_SUCCESS) {
      let { list } = nextProps.nhapkho;
      var optionsDvt = list.map((item, idx) => {
        return { value: item.DvtId, label: item.Ten }
      });
      this.setState({ optionsDvt });
    }

  }
  //=== Handle change==============//
  handleNccChange = selectedOptionNcc => {
    let { itemNhap } = this.state
    itemNhap.nhaccId = selectedOptionNcc.value
    itemNhap.nhaccTen = selectedOptionNcc.label
    this.setState({ itemNhap, selectedOptionNcc });
  };
  handleKhoChange = selectedOptionKho => {
    let { itemNhap, kho_id } = this.state
    itemNhap.khoId = selectedOptionKho.value
    kho_id = selectedOptionKho.value
    itemNhap.tenKho = selectedOptionKho.label
    this.setState({ itemNhap, selectedOptionKho, kho_id });
  };
  handleSelectChange = (name, selectedOption) => {
    let { itemNhap, productCtl } = this.state
    switch (name) {
      case "TrangThai":
        itemNhap.trangThai = selectedOption.target.value
        this.setState({ itemNhap })
        break;
      case "loaiHd":
        itemNhap.loaiHd = parseInt(selectedOption.target.value)
        this.setState({ itemNhap }, e => { 
          this.getListKhachHang('')
          if (productCtl) {
            productCtl.handleClearClick()
          }
        })
        break;
      default:
        break;
    }
  }
  handleControlChange = (name, e) => {
    let { itemNhap } = this.state
    switch (name) {
      case "SoPhieu":
        itemNhap.soPhieu = e.target.value
        this.setState({
          itemNhap
        });
        break;
      case "MaSoThue":
        itemNhap.maSoThue = e.target.value
        this.setState({
          itemNhap
        });
        break;
      case "GhiChu":
        itemNhap.ghiChu = e.target.value
        this.setState({
          itemNhap
        });
        break;
      default:
        break;
    }
  }
  handleSoluongNhapChange(item, data) {
    const value = data.floatValue || 1;
    this.updateSoluongNhap(item.idproduct, value);
  }

  updateSoluongNhap = (idproduct, soluongnhap) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].SoluongNhap = soluongnhap;
      list[index].SoLuong = list[index].SoluongNhap * list[index].QuyCach

      var tienChuaVat = list[index].MoneyIm * list[index].SoLuong
      var _vat = list[index].Vat || 0
      var tienVat = tienChuaVat * (_vat / 100)
      var _ck = list[index].ChietKhau || 0
      var tienCK = tienChuaVat * (_ck / 100)
      list[index].TienVat = tienVat;
      list[index].TienCk = tienCK;
      list[index].TienTruocVat = tienChuaVat;
      list[index].Amount = (tienChuaVat + tienVat) - tienCK;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleQuyCachChange(item, data) {
    const value = data.floatValue || 1;
    this.updateQuyCach(item.idproduct, value);
  }
  updateQuyCach = (idproduct, QuyCach) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].QuyCach = QuyCach;
      list[index].SoLuong = list[index].SoluongNhap * list[index].QuyCach

      var tienChuaVat = list[index].MoneyIm * list[index].SoLuong
      var _vat = list[index].Vat || 0
      var tienVat = tienChuaVat * (_vat / 100)
      var _ck = list[index].ChietKhau || 0
      var tienCK = tienChuaVat * (_ck / 100)
      list[index].TienVat = tienVat;
      list[index].TienCk = tienCK;
      list[index].TienTruocVat = tienChuaVat;
      list[index].Amount = (tienChuaVat + tienVat) - tienCK;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleDvtBanChange = (item, optionSelected) => {
    this.updateDvtBan(item.idproduct, optionSelected);
  }
  updateDvtBan = (idproduct, optionSelected) => {
    var index = optionSelected.target.selectedIndex;
    var text = optionSelected.target[index].text;
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].DvtId = optionSelected.target.value;
      list[index].DvtTen = text;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleMoneyImChange(item, data) {
    const value = data.floatValue || 0;
    this.updateMoneyIm(item.idproduct, value);
  }
  updateMoneyIm = (idproduct, moneyim) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].MoneyIm = moneyim;

      var tienChuaVat = list[index].MoneyIm * list[index].SoLuong
      var _vat = list[index].Vat || 0
      var tienVat = tienChuaVat * (_vat / 100)
      var _ck = list[index].ChietKhau || 0
      var tienCK = tienChuaVat * (_ck / 100)
      list[index].TienVat = tienVat;
      list[index].TienCk = tienCK;
      list[index].TienTruocVat = tienChuaVat;
      list[index].Amount = (tienChuaVat + tienVat) - tienCK;

      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleMoneyOutChange(item, data) {
    const value = data.floatValue || 0;
    this.updateMoneyOut(item.idproduct, value);
  }
  updateMoneyOut = (idproduct, moneyuot) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].MoneyOut = moneyuot;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleVatChange(item, data) {
    const value = data.floatValue || 0;

    this.updateVat(item.idproduct, value);
  }
  updateVat = (idproduct, vat) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].Vat = vat;
      var tienChuaVat = list[index].MoneyIm * list[index].SoLuong
      var tienVat = tienChuaVat * (vat / 100)
      var _ck = list[index].ChietKhau || 0
      var tienCK = tienChuaVat * (_ck / 100)
      list[index].TienVat = tienVat;
      list[index].TienCk = tienCK;
      list[index].TienTruocVat = tienChuaVat;
      list[index].Amount = (tienChuaVat + tienVat) - tienCK;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleChietKhauChange(item, data) {
    const value = data.floatValue || 0;
    this.updateChietKhau(item.idproduct, value);
  }
  updateChietKhau = (idproduct, ck) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].ChietKhau = ck;

      var tienChuaVat = list[index].MoneyIm * list[index].SoLuong
      var _vat = list[index].Vat || 0
      var tienVat = tienChuaVat * (_vat / 100)
      var tienCK = tienChuaVat * (ck / 100)
      list[index].TienVat = tienVat;
      list[index].TienCk = tienCK;
      list[index].TienTruocVat = tienChuaVat;
      list[index].Amount = (tienChuaVat + tienVat) - tienCK;

      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }

  handleSoLoChange(item, event) {
    this.updateSoLo(item.idproduct, event.target.value);
  }
  updateSoLo = (idproduct, solo) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].SoLo = solo;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleBarCodeChange(item, event) {
    this.updateBarCode(item.idproduct, event.target.value);
  }
  updateBarCode = (idproduct, barcode) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].BarCode = barcode;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  handleHanDungChange(item, date) {
    this.updateHanDung(item.idproduct, date);
  }
  updateHanDung = (idproduct, date) => {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === idproduct);
    if (index > -1) {
      list[index].HanDung = date;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }

  handleDateChange = (date) => {
    this.setState({ NgayNhap: date });
  }
  sum = (items, prop) => {
    return items.reduce(function (a, b) {
      return a + b[prop];
    }, 0);
  }
  updateInfo = () => {
    let { list, TotalAmount, Refund, TotalPay, TotalVisitorPay, itemNhap } = this.state;
    TotalAmount = this.sum(list, 'Amount');
    TotalPay = TotalAmount;
    Refund = TotalVisitorPay > 0 ? TotalVisitorPay - TotalPay : 0;
    var TongTienVat = this.sum(list, 'TienVat');
    var TongTienCk = this.sum(list, 'TienCk');
    var TongTienTruocVat = this.sum(list, 'TienTruocVat');
    itemNhap.tongTienVat = TongTienVat;
    itemNhap.tongTienCk = TongTienCk;
    itemNhap.tongTienTruocVat = TongTienTruocVat;
    itemNhap.tongTienSauVat = TotalAmount;
    this.setState({ TotalAmount, Refund, TotalPay, itemNhap });
  }

  //=== End Handle change==============//

  submit = (callback) => {
    const { nhapkhoSaveRequest } = this.props
    let { itemNhap,list } = this.state
    if (this.state.list.length <= 0) {
      this.setState({ MessWarning: "Chưa chọn thuốc nào" });
      return;
    }
    if (Object.keys(itemNhap).length == 0) {
      return;
    }
    list && list.forEach(function (item) {
      item.HanDung= item.HanDung && formatDateTime(item.HanDung);
    });
    if (!itemNhap.khoId || itemNhap.khoId == "") {
      this.setState({ MessWarning: "Chưa chọn kho" });
      return;
    }
    var requestData = {
      store_id: this.state.store_id,
      items: list,
      ngaynhap: formatDateTime(this.state.NgayNhap),
      itemNhap: this.state.itemNhap,
    }
    return nhapkhoSaveRequest(requestData, callback)
  }
  addItem(option) {
    var { list } = this.state;
    var index = list.findIndex(x => x.idproduct === option.idproduct);
    if (index > -1) {
      let objCur = {};
      let Arr = [];
      let listCus = [];
      list[index].SoluongNhap = list[index].SoluongNhap + 1;
      list[index].SoLuong = list[index].SoluongNhap * list[index].QuyCach

      var tienChuaVat = list[index].MoneyIm * list[index].SoLuong
      var _vat = list[index].Vat || 0
      var tienVat = tienChuaVat * (_vat / 100)
      var _ck = list[index].ChietKhau || 0
      var tienCK = tienChuaVat * (_ck / 100)
      list[index].Amount = (tienChuaVat + tienVat) - tienCK;
      // tách list để đảo ngược dòng đang  sửa lên đầu tiên
      objCur =list[index];
      Arr = list.filter(item => item.idproduct != option.idproduct);
      listCus.concat(Arr);
      Arr.map((item) => { listCus.push(item) }
      );
      listCus.push(objCur);
      list = listCus;
    }
    else {
      let soluong = option.QuyCach * 1;
      let amount = option.gianhap * soluong;
      list.push({
        Sku: option.sku, Name: option.label, SoluongNhap: 1, QuyCachDongGoi: option.QuyCachDongGoi || "",
        MoneyOut: option.giaban, MoneyIm: option.gianhap, Amount: amount, SoLuong: soluong,
        QuyCach: option.QuyCach, SoLo: "", HanDung: this.state.HanDung, DvtTen: option.DvtTen, DvtId: option.DvtId,
        idproduct: option.idproduct, BarCode: option.BarCode || "", tonkho: option.tonkho,
        Vat: 0, ChietKhau: 0, TienVat: 0, TienCk: 0, TienTruocVat: amount
      });
    }
    list= list.reverse();
    this.setState({ list, MessWarning: "" }, () => {
      this.setSoundStatus(mp3AddItem);
      this.updateInfo();
      let quantityName = 'SoluongNhap0';
      setTimeout(() => {
        $('#tblProduct').find("input[name='" + quantityName + "']").focus().select();
      }, 100)
    });
  }

  genBarCode = (productId) => {
    var { list } = this.state;
    var barcode = barCodeFirst(productId);
    var index = list.findIndex(x => x.idproduct === productId);
    if (index > -1) {
      list[index].BarCode = barcode;
      this.setState({ list }, () => {
        this.updateInfo();
      });
    }
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  setSoundStatus(url) {
    this.setState({ soundUrl: url, playSound: Sound.status.PLAYING })
    setTimeout(() => {
      this.setState({ playSound: Sound.status.STOPPED })
    }, 1500)
  }

  /*========================== Khách hàng ========================*/

  getListKhachHang = (keyword, callback) => {
    const formData = {
      store_id: this.state.store_id,
      keyword: keyword,
      per_page: 20,
      loai_dh: this.state.itemNhap.loaiHd
    }
    if (formData.loai_dh == nhapkhoConstant.LOAI_DH.TU_NCC) {
      this.onHandleSelectCustomerChange()
      return this.formatCustomerOptions([])
    }
    const onSuccess = (data) => {
      this.formatCustomerOptions(data)
      if (callback) {
        callback(data)
      }
    }
    return this.props.loadKhachHang(formData, onSuccess)
  }
  customerChanged = (input, callback) => {
    this.getListKhachHang(input, callback);
  }
  onHandleSelectCustomerChange = (selectedOption) => {
    let { itemNhap } = this.state
    selectedOption = selectedOption || {value: 0, label: ''}
    itemNhap.customerId = selectedOption.value
    itemNhap.customerName = selectedOption.label
    this.setState({itemNhap})
  }
  setCustomersCtl = (e) => {
    this.setState({customersCtl: e});
  }
  formatCustomerOptionLabel = (option) => {
    return (
      <div className="item">
        {'\u00A0'}{'\u00A0'}
        {option.label}<span className={"item_unit"}>{'\u00A0'}({option.dienthoai})</span>
        <div><span className={"item_unit"}>{'\u00A0'}({option.diachi})</span></div>
      </div>
    )
  }
  formatCustomerNoOptionLabel = (input) => {
    return (
      <Fragment>
        <div><em>Không tìm thấy</em></div>
      </Fragment>
    )
  }
  formatCustomerOptions = (list) => {
    let customerSuggestions = [];
    list.forEach(function (item) {
      let option = null;
      const label = item.Ma ? `${item.Ma}-${item.Ten}` : `ĐL-${item.Ten}`
      option = {
        value: item.Id,
        label: label,
        dienthoai: item.DienThoai,
        ma: item.Ma,
        ten: item.ten,
        diachi: item.DiaChi,
      };

      customerSuggestions.push(option);
    });

    this.setState({ customerSuggestions });
  }

  /*========================== Khách hàng ========================*/

  render() {
    const { 
      list, 
      MessWarning, 
      optionsDvt, 
      selectedOptionNcc, 
      selectedOptionKho, 
      itemNhap,
      customerSuggestions
    } = this.state
    const {
      handleSubmit,
      nhapkho: {
        requesting,
        messages,
        errors,
      },
    } = this.props

    const isReturnProducts = itemNhap.loaiHd != nhapkhoConstant.LOAI_DH.TU_NCC
    return (
      <div className="animated fadeIn">
        <Row>
          <Col md="4" sm="6" xs="12" className="mb-2 pr-2 pl-2" >
            <InputGroup size="md">
              <InputGroupAddon className="d-none d-sm-block" addonType="prepend" >Nhà cung cấp</InputGroupAddon>
              <InputGroupAddon className="d-block d-sm-none" addonType="prepend" >Ncc</InputGroupAddon>
              <Select
                styles={customSelectStyles}
                placeholder="Tên"
                value={selectedOptionNcc}
                onChange={this.handleNccChange}
                options={this.state.listNcc}
                className="form-control p-0"
              />
            </InputGroup>
          </Col>
          <Col md="4" sm="6" xs="6" className="mb-2 pr-2 pl-2" >
            <InputGroup size="md">
              <InputGroupAddon className="d-none d-sm-block" addonType="prepend" >Chọn kho</InputGroupAddon>
              <InputGroupAddon className="d-block d-sm-none" addonType="prepend" >Kho</InputGroupAddon>
              <Select
                styles={customSelectStyles}
                placeholder="Tên kho"
                value={selectedOptionKho}
                onChange={this.handleKhoChange}
                options={this.state.listKho}
                className="form-control p-0"
              />
            </InputGroup>
          </Col>
          <Col md="4" sm="6" xs="6" className="mb-2 pr-2 pl-2" >
            <InputGroup size="md">
              <InputGroupAddon addonType="prepend" autoComplete="off" >Số phiếu</InputGroupAddon>
              <Input name="SoPhieu" placeholder="Số phiếu" value={itemNhap.soPhieu || ''}
                autoComplete="off"
                onChange={this.handleControlChange.bind(this, "SoPhieu")}
              />
            </InputGroup>
          </Col>
          <Col md="4" sm="6" xs="6" className="mb-2 pr-2 pl-2" >
            <InputGroup size="md">
              <InputGroupAddon className="d-none d-sm-block" addonType="prepend" >Mã số thuế</InputGroupAddon>
              <InputGroupAddon className="d-block d-sm-none" addonType="prepend" >MST</InputGroupAddon>
              <Input name="MaSoThue" placeholder="Mã số thuế" value={itemNhap.maSoThue || ''}
                autoComplete="off"
                onChange={this.handleControlChange.bind(this, "MaSoThue")}
              />
            </InputGroup>
          </Col>
          <Col md="4" sm="6" xs="6" className="mb-2 pr-2 pl-2" >
            <InputGroup size="md">
              <select className="form-control" value={itemNhap.trangThai || 0} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={0}>Chưa duyệt</option>
                <option value={1}>Đã duyệt</option>
              </select>
            </InputGroup>
          </Col>
          <Col md="4" sm="6" xs="6" className="mb-2 pr-2 pl-2" >
            <InputGroup size="md">
              <select className="form-control" value={itemNhap.loaiHd} 
                onChange={this.handleSelectChange.bind(this, "loaiHd")}>
                <option value={nhapkhoConstant.LOAI_DH.TU_NCC}>--Nhập từ nhà CC--</option>
                <option value={nhapkhoConstant.LOAI_DH.DON_THUONG}>Nhập từ khách lẻ</option>
                <option value={nhapkhoConstant.LOAI_DH.DON_DAI_LY}>Nhập từ đại lý</option>
              </select>
            </InputGroup>
          </Col>
          {isReturnProducts && (
            <Col md="4" sm="6" xs="6" className="mb-2 pr-2 pl-2" >
              <Autocomplete
                name="customerSelect"
                placeholder={"Nhập tên, số điện thoại"}
                clearOnSelection={false}
                formatOptionLabel={this.formatCustomerOptionLabel}
                formatNoOptionLabel={this.formatCustomerNoOptionLabel.bind(this)}
                handleChange={this.customerChanged.bind(this)}
                onSelection={this.onHandleSelectCustomerChange.bind(this)}
                suggestions={customerSuggestions}
                onRef={(ctl) => this.setCustomersCtl(ctl)}
            />
          </Col>
          )}
          <Col md={isReturnProducts ? 8 : 12} sm="6" xs="12" className="mb-2 pr-2 pl-2" >
            <InputGroup size="md">
              <Input className="form-control" name="GhiChu" placeholder="Nhập ghi chú"
                autoComplete="off"
                onChange={this.handleControlChange.bind(this, "GhiChu")}
                value={itemNhap.ghiChu || ''}>
              </Input>
            </InputGroup>
          </Col>
          <Col xs="12" sm="12" md="12" className="mb-2 pr-2 pl-2">
            <div className="form-group">
              <Autocomplete
                name="productSelect"
                placeholder="Nhập tên hàng, mã hàng"
                setFocus={false}
                selectOnTab={true}
                clearOnSelection={true}
                formatOptionLabel={this.formatOptionLabel}
                formatNoOptionLabel={this.formatNoOptionLabel.bind(this)}
                handleChange={this.productChanged.bind(this)}
                onSelection={this.onHandleSelectChange.bind(this)}
                suggestions={this.state.suggestions}
                initParams={this.setCloseSuggessHandle}
              />
            </div>
          </Col>
        </Row>
        <BlockUi tag="div" blocking={requesting}>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <Table className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <Thead className="thead-default">
                  <Tr>
                    <Th scope="col" className="text-left">Số lượng</Th>
                    {/* <Th scope="col" className="text-left ">Quy cách</Th> */}
                    <Th scope="col" className="text-center table-border-right">ĐVT</Th>
                    <Th scope="col" className="text-right table-border-right"><span className="number-th82">Giá nhập</span></Th>
                    {/* <Th scope="col" className="text-center table-border-right"><span className="number-th">Giá bán</span></Th> */}
                    <Th scope="col" className="text-center table-border-right"><span >Vat(%)</span></Th>
                    <Th scope="col" className="text-center table-border-right"><span >C.Khấu(%)</span></Th>
                    <Th scope="col" className="text-justify table-border-right"><span className="number-th">Thành tiền</span></Th>
                    <Th scope="col" className="text-center table-border-right"><span className="number-th">Hạn dùng</span></Th>
                    <Th scope="col" className="text-center table-border-right"><span className="number-th">Số lô</span></Th>
                    <Th scope="col" className="text-center"></Th>
                  </Tr>
                </Thead>
                <Tbody id="tblProduct">
                  {list && !!list.length && (                                                                                                                                                       
                    list.map((res, idx) => [(
                      <Tr key={"p-name-" + (idx + 1)}>
                        <Td colSpan="14" className="table-border-right table-td-padding5">
                          <div className="item">
                            <div className="pull-left"> {`${res.Sku }/ ${res.Name}`}
                             </div>
                            {res.tonkho != "" ? <div className={"text-danger pull-left"}> ({res.tonkho})</div> : null}
                            {
                              res.QuyCachDongGoi != "" ? <div className="text-primary pull-left"> {res.QuyCachDongGoi}</div>
                                : null}
                          </div>
                        </Td>
                      </Tr>),
                    (<Tr key={idx + 1}>
                      <Td width="40" className="text-justify table-border-right table-td-padding5">
                        <NumberFormat
                          name={"SoluongNhap" + idx}
                          tabIndex="10"
                          value={res.SoluongNhap}
                          defaultValue={1}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          type="tel"
                          autoComplete="off"
                          onClick={this.numberOnclick.bind(this)}
                          onValueChange={this.handleSoluongNhapChange.bind(this, res)}
                          className={"order-input-sl price number"} />
                      </Td>
                      <Td className="text-right table-border-right table-td-padding5" width="80">
                        {res.DvtTen}
                        {/* <select name="DvtBan" className={"form-control selectCus"} onChange={this.handleDvtBanChange.bind(this, res)}
                          defaultValue={res.DvtId}>
                          {
                            optionsDvt && optionsDvt.map(itemOp => {
                              return (
                                <option key={itemOp.value} value={itemOp.value}>
                                  {itemOp.label}</option>
                              )
                            })
                          }
                        </select> */}
                      </Td>
                      <Td className="text-justify table-border-right table-td-padding5" width="70">
                        <Tooltip content={"Giá nhập của 1(" + res.DvtTen + ")"} position='top' trigger='click'>
                          <NumberFormat
                            name={"MoneyIm" + idx}
                            value={res.MoneyIm}
                            defaultValue={0}
                            thousandSeparator={"."}
                            decimalSeparator={","}
                            type="tel"
                            autoComplete="off"
                            onClick={this.numberOnclick.bind(this)}
                            onValueChange={this.handleMoneyImChange.bind(this, res)}
                            className={"order-input-price price number"} />
                        </Tooltip>
                      </Td>
                      {/* <Td className="text-justify table-border-right table-td-padding5" width="70">
                        <NumberFormat
                          name={"MoneyOut" + idx}
                          value={res.MoneyOut}
                          defaultValue={0}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          type="tel"
                          autoComplete="off"
                          onClick={this.numberOnclick.bind(this)}
                          onValueChange={this.handleMoneyOutChange.bind(this, res)}
                          className={"order-input-price price number"} />
                      </Td> */}
                      <Td width="20" className="text-justify table-border-right table-td-padding5">
                        <NumberFormat
                          name={"Vat" + idx}
                          value={res.Vat}
                          defaultValue={1}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          type="tel"
                          autoComplete="off"
                          onClick={this.numberOnclick.bind(this)}
                          onValueChange={this.handleVatChange.bind(this, res)}
                          className={"order-input-sl price number50"} />
                      </Td>
                      <Td width="40" className="text-justify table-border-right table-td-padding5">
                        <NumberFormat
                          name={"ChietKhau" + idx}
                          value={res.ChietKhau}
                          defaultValue={1}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          type="tel"
                          autoComplete="off"
                          onClick={this.numberOnclick.bind(this)}
                          onValueChange={this.handleChietKhauChange.bind(this, res)}
                          className={"order-input-sl price number60"} />
                      </Td>
                      <Td className="text-right table-border-right table-td-padding5">{res.Amount && res.Amount.toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</Td>
                      <Td className="text-center table-border-right table-td-padding5" width="90">
                        <DatePicker name="expirationDate"
                          selected={parseDatetime(res.HanDung, null)}
                          onChange={this.handleHanDungChange.bind(this, res)}
                          required className={"form-control add_date_ex"}
                          autoComplete="off"
                          dateFormat="DD/MM/YYYY" />
                      </Td>
                      <Td className="text-justify table-border-right table-td-padding5">
                        <input name={"SoLo" + idx} type="text"
                          value={res.SoLo || ""}
                          onChange={this.handleSoLoChange.bind(this, res)} width="90" className=" order-input-price price number"
                          autoComplete="off" />
                      </Td>
                      <Td scope="row" width="20" className="text-center table-td-padding5">
                        <Button color="danger" onClick={this.removeItem.bind(this, res)}><i className="fa fa-trash-o"></i></Button>
                      </Td>
                    </Tr>
                    )])
                  )}
                  <Tr>
                    <Td className="table-border-right font-weight-bold" colSpan="6">Tổng tiền</Td>
                    <Td className="text-right table-border-right">{this.state.TotalAmount && this.state.TotalAmount.toLocaleString("vi-VN", { minimumFractionDigits: 0 })}{'\u00A0'}₫</Td>
                    <Td className="text-right table-border-right" colSpan="3"></Td>
                  </Tr>
                </Tbody>
              </Table>
              {/* Audio */}
              <Sound
                url={this.state.soundUrl}
                playStatus={this.state.playSound}
              />
              {/* End Audio */}
              <div className="clearfix">
                <Row>
                  <Col md="12">
                    {!requesting && !!errors.length && (
                      <Errors message="Failure to signup due to:" errors={errors} />
                    )}
                    {!requesting && !!messages.length && (
                      <Messages messages={messages} />
                    )}
                    <div className="messages-feedback">{MessWarning}</div>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" sm="12" md="12">
                    <div className="btn-group float-right" role="group">
                      <p className="labledate" >Ngày<span className="d-none d-sm-inline"> làm việc</span>: </p>
                      <DatePicker name="NgayNhap" selected={this.state.NgayNhap} onChange={this.handleDateChange.bind(this)} required className={"form-control"} autoComplete="off" dateFormat="DD/MM/YYYY" />
                      <ButtonExt className="mr-1"
                        color="primary"
                        iconClass="fa fa-save"
                        displayText="&nbsp;Nhập kho"
                        btnClick={handleSubmit(this.submit)}
                        permission={BtnPermissions.NhapHang.ADD} />&nbsp;
                      <ButtonExt className="mr-1"
                        color="secondary"
                        iconClass="fa fa-arrow-left"
                        displayText="&nbsp;Danh sách"
                        btnClick={this.listDsNhap}
                        permission={""} />
                      {/* <Button className="btn btn-secondary" onClick={this.listDsNhap}>
                        <i className="fa fa-arrow-left"></i><span className="d-none d-sm-inline">&nbsp;Danh sách</span></Button> */}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  nhapkho: state.nhapkho,
  client: state.client,
})

const connected = connect(mapStateToProps,
  {
    nhapkhoListNhaCCRequest: nhapkhoAction.nhapkhoListNhaCCRequest,
    nhapkhoListKhoRequest: nhapkhoAction.nhapkhoListKhoRequest,
    nhapkhoListProductRequest: nhapkhoAction.nhapkhoListProductRequest,
    nhapkhoSaveRequest: nhapkhoAction.nhapkhoSaveRequest,
    nhapkhoProductsListDvtRequest: nhapkhoAction.nhapkhoProductsListDvtRequest,
    loadKhachHang: nhapkhoAction.loadKhachHang
  })(NhapKho)

const formed = reduxForm({
  form: 'nhapkho',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/NhapKho/NhapKho.js